import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, CheckCircle2, Folder } from 'lucide-react';
const tomos = [{
  num: '1',
  title: 'EL DIAGNÓSTICO CRÍTICO',
  desc: 'Auditoría completa de tu CV actual. Los 11 errores que te están costando entrevistas. Plan de acción de 7 días para empezar hoy.',
  color: 'text-amber-300',
  bg: 'bg-amber-300/10',
  border: 'border-amber-300',
  shadow: 'shadow-[0_0_20px_rgba(252,211,77,0.5)] hover:shadow-[0_0_35px_rgba(252,211,77,0.85)]'
}, {
  num: '2',
  title: 'INGENIERÍA ANTI-ATS',
  desc: 'Cómo funcionan los filtros automáticos en Argentina. Sistema de Relevancia Forzada (SRF). Banco de palabras clave por industria.',
  color: 'text-yellow-400',
  bg: 'bg-yellow-400/10',
  border: 'border-yellow-400',
  shadow: 'shadow-[0_0_20px_rgba(250,204,21,0.5)] hover:shadow-[0_0_35px_rgba(250,204,21,0.85)]'
}, {
  num: '3',
  title: 'EL PERFIL DE ALTO IMPACTO',
  desc: 'Tu Propuesta de Valor Profesional. Título y perfil que generan deseo de llamarte. Optimización de LinkedIn paso a paso.',
  color: 'text-gold',
  bg: 'bg-gold/10',
  border: 'border-gold',
  shadow: 'shadow-[0_0_20px_rgba(212,166,42,0.5)] hover:shadow-[0_0_35px_rgba(212,166,42,0.85)]'
}, {
  num: '4',
  title: 'EXPERIENCIA GANADORA',
  desc: 'Método STAR para convertir funciones en logros medibles. Cómo usar números sin mentir. Banco de verbos de poder por nivel.',
  color: 'text-yellow-200',
  bg: 'bg-yellow-200/10',
  border: 'border-yellow-200',
  shadow: 'shadow-[0_0_20px_rgba(254,240,138,0.5)] hover:shadow-[0_0_35px_rgba(254,240,138,0.85)]'
}, {
  num: '5',
  title: 'LA CARTA DE ASALTO',
  desc: 'Mail de postulación perfecto. Carta de presentación de alto impacto. Scripts exactos para mensajes de LinkedIn.',
  color: 'text-amber-400',
  bg: 'bg-amber-400/10',
  border: 'border-amber-400',
  shadow: 'shadow-[0_0_20px_rgba(251,191,36,0.5)] hover:shadow-[0_0_35px_rgba(251,191,36,0.85)]'
}, {
  num: '6',
  title: 'KIT DE PLANTILLAS',
  desc: 'Plantillas editables listas para usar. CV Anti-ATS, carta, mail y mensajes. Checklists de revisión final.',
  color: 'text-gold',
  bg: 'bg-gold/10',
  border: 'border-gold',
  shadow: 'shadow-[0_0_20px_rgba(212,166,42,0.5)] hover:shadow-[0_0_35px_rgba(212,166,42,0.85)]'
}];
const inclusions = ['Checklists, tablas y plantillas accionables', 'Diseñado para el mercado laboral argentino', 'Aplicable desde el primer día sin experiencia técnica', 'Palabras clave reales por industria y posición'];
export function TomosSection() {
  return <section className="py-9 bg-petroleum/30 border-y border-electric/10" data-id="element-693">
      <div className="container mx-auto px-4" data-id="element-694">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-3xl mx-auto mb-8" data-id="element-695">
          {/* Section Folder Tab */}
          <div className="absolute -top-6 left-6 md:left-10 z-20" data-id="element-696">
            <div className="bg-petroleum border-2 border-b-0 border-electric/40 rounded-t-lg px-4 py-1.5 flex items-center gap-2 transform -rotate-2" data-id="element-697">
              <Folder className="w-3.5 h-3.5 text-electric" data-id="element-698" />
              <span className="text-[11px] font-mono font-bold uppercase tracking-widest text-electric" data-id="element-699">
                Contenido del Expediente
              </span>
            </div>
          </div>

          {/* Outer glow */}
          <div className="absolute -inset-1 bg-gradient-to-r from-electric via-yellow-300 to-electric rounded-3xl blur-xl opacity-40 animate-pulse" data-id="element-700"></div>

          {/* Frame */}
          <div className="relative bg-gradient-to-br from-graphite via-petroleum to-graphite border-2 border-electric rounded-3xl p-5 md:p-7 text-center overflow-hidden shadow-2xl shadow-electric/30" data-id="element-701">
            {/* Grid pattern background */}
            <div className="absolute inset-0 opacity-[0.10] pointer-events-none" style={{
            backgroundImage: 'linear-gradient(rgba(201,151,30,0.7) 1px, transparent 1px), linear-gradient(90deg, rgba(201,151,30,0.7) 1px, transparent 1px)',
            backgroundSize: '24px 24px'
          }} data-id="element-702"></div>

            {/* Corner accents */}
            <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-electric rounded-tl-3xl pointer-events-none" data-id="element-703"></div>
            <div className="absolute top-0 right-0 w-16 h-16 border-t-4 border-r-4 border-electric rounded-tr-3xl pointer-events-none" data-id="element-704"></div>
            <div className="absolute bottom-0 left-0 w-16 h-16 border-b-4 border-l-4 border-electric rounded-bl-3xl pointer-events-none" data-id="element-705"></div>
            <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-electric rounded-br-3xl pointer-events-none" data-id="element-706"></div>

            <div className="relative z-10" data-id="element-707">
              {/* Metadata header strip */}
              <div className="border-b border-dashed border-white/10 pb-2 mb-4 text-[10px] font-mono uppercase tracking-widest text-textsecondary flex justify-center gap-4" data-id="element-708">
                <span data-id="element-709">Expediente N° 047</span>
                <span data-id="element-710">•</span>
                <span data-id="element-711">Confidencial</span>
              </div>

              <div className="inline-flex items-center gap-2 bg-electric text-graphite font-extrabold tracking-widest uppercase text-xs px-4 py-1.5 rounded-full mb-3 shadow-lg shadow-electric/40" data-id="element-712">
                <span className="w-6 h-px bg-graphite" data-id="element-713"></span>
                El Sistema Completo
                <span className="w-6 h-px bg-graphite" data-id="element-714"></span>
              </div>
              <h2 className="text-3xl md:text-5xl font-extrabold mb-3" data-id="element-715">
                🏆 SUPERPACK ENTREVISTAS:
                <br data-id="element-716" />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-electric via-yellow-300 to-electric drop-shadow-[0_0_12px_rgba(201,151,30,0.4)]" data-id="element-717">
                  EL SISTEMA COMPLETO PARA CONSEGUIR TRABAJO
                </span>
              </h2>
              <div className="mx-auto h-px w-32 bg-gradient-to-r from-transparent via-electric to-transparent opacity-70 mb-3" data-id="element-718"></div>
              <p className="text-lg md:text-xl text-textsecondary" data-id="element-719">
                6 Tomos + 6 Bonos — De CV Invisible a Entrevistas Reales ·{' '}
                <span className="text-white font-bold" data-id="element-720">
                  300+ páginas. Todo resuelto.
                </span>
              </p>
            </div>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6" data-id="element-721">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`bg-cardbg rounded-2xl p-5 border-2 border-white/5 transition-all duration-300 group relative overflow-hidden hover:-translate-y-1 mt-4`} data-id="element-722">
              {/* Card Folder Tab */}
              <div className="absolute top-0 left-0 right-0 flex justify-center -mt-0.5" data-id="element-723">
                <div className={`bg-petroleum border-b-2 ${tomo.border} px-4 py-1 rounded-b-lg shadow-md`} data-id="element-724">
                  <span className={`text-[10px] font-mono font-bold uppercase tracking-widest ${tomo.color}`} data-id="element-725">
                    Tomo 0{tomo.num}
                  </span>
                </div>
              </div>

              {/* Ruled-paper lines */}
              <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
            backgroundImage: 'repeating-linear-gradient(0deg, #ffffff 0px, #ffffff 1px, transparent 1px, transparent 24px)',
            marginTop: '24px'
          }} data-id="element-726"></div>

              <div className={`absolute top-0 right-0 w-32 h-32 ${tomo.bg} blur-3xl rounded-full -mr-10 -mt-10 transition-opacity group-hover:opacity-100 opacity-50`} data-id="element-727"></div>

              <div className="flex items-center gap-4 mb-4 relative z-10 mt-4" data-id="element-728">
                <div className={`w-12 h-12 rounded-xl ${tomo.bg} ${tomo.color} flex items-center justify-center font-bold text-xl border border-white/10`} data-id="element-729">
                  {tomo.num}
                </div>
                <BookOpen className={`w-6 h-6 ${tomo.color} opacity-50`} data-id="element-730" />
              </div>

              <h3 className="text-lg font-bold mb-2 relative z-10" data-id="element-731">
                Tomo {tomo.num} — {tomo.title}
              </h3>
              <p className="text-textsecondary text-sm leading-relaxed relative z-10" data-id="element-732">
                {tomo.desc}
              </p>
            </motion.div>)}
        </div>

        <div className="max-w-3xl mx-auto bg-graphite rounded-2xl p-6 border border-electric/20" data-id="element-733">
          <h4 className="text-center font-bold text-xl mb-4" data-id="element-734">
            Cada tomo incluye:
          </h4>
          <div className="grid sm:grid-cols-2 gap-4" data-id="element-735">
            {inclusions.map((inc, i) => <div key={i} className="flex items-start gap-3" data-id="element-736">
                <CheckCircle2 className="w-5 h-5 text-electric shrink-0 mt-0.5" data-id="element-737" />
                <span className="text-textsecondary text-sm" data-id="element-738">{inc}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}